// src/constants/colors.js
export const AVAILABLE_COLORS = [
    "Black",
    "White",
    "Silver",
    "Gray",
    "Red",
    "Blue",
    "Green",
    "Yellow",
    "Orange",
    "Brown",
    "Dark gary",
    "Other"
  ];
  